import React from 'react';
import ModalWrapper from '../modal/modal-wrapper/ModalWrapper';
import { ModalSize, ModalStyleType } from '../../models/enum';
import {
  Card,
  CardHeader,
  CardText,
  HeaderContentWrapper,
  ImageWrapper,
  LinksWrapper,
  ModalContentWrapper,
  StyledLink,
  Subheader,
} from './ReservedAreaModal.style';
import Markdown from '../markdown/Markdown';
import { SingleStrapiImage } from '../../models/domain/interfaces';
import Link from 'next/link';
import { hexToRgb, rgbDataURL } from 'corporate-utils';
import { getStrapiMedia } from '../../utils/media';
import { ReservedArea } from '../../models/auto-generated-strapi-types/types/components/ReservedArea';
import { DEFAULT_IMAGE } from '../../models/domain/const';
import ImageWithFallback from '../image-with-fallback/ImageWithFallback';

interface IProps {
  open: boolean;
  handleClose: () => void;
  logo: SingleStrapiImage;
  isPrerenderRequest: boolean;
}

type ReservedAreaProps = IProps &
  Omit<ReservedArea, 'buttonText'> & { title: string; cards: any } & any;

const ReservedAreaModal: React.FC<ReservedAreaProps> = ({
  open,
  handleClose,
  title,
  text,
  cards,
  logo,
  isPrerenderRequest,
}) => {
  return (
    <ModalWrapper
      show={open}
      hideModal={handleClose}
      size={ModalSize.BIG}
      showDefaultHeader={false}
      styleType={ModalStyleType.reservedArea}
    >
      <ModalContentWrapper>
        <ModalWrapper.Header typeHeader="content" onClose={handleClose}>
          <HeaderContentWrapper>
            <ModalWrapper.Title
              title={<Markdown>{title}</Markdown>}
              styleType={ModalStyleType.reservedArea}
            />
            {text && <Subheader>{text}</Subheader>}
          </HeaderContentWrapper>
        </ModalWrapper.Header>
        <ModalWrapper.Body styleType={ModalStyleType.reservedArea}>
          <LinksWrapper>
            {React.Children.toArray(
              cards?.map?.(({ text, url, linkText, newTab, type }: any) => (
                <Card>
                  <CardHeader>
                    <ImageWrapper>
                      <ImageWithFallback
                        layout="fill"
                        objectFit="contain"
                        objectPosition="left"
                        placeholder="blur"
                        blurDataURL={rgbDataURL(
                          hexToRgb('ffffff')?.[0],
                          hexToRgb('ffffff')?.[1],
                          hexToRgb('ffffff')?.[2]
                        )}
                        src={getStrapiMedia(logo?.data?.attributes?.url || '')}
                        alt={logo?.data?.attributes?.alternativeText}
                        fallbackSrc={DEFAULT_IMAGE}
                        isPrerenderRequest={isPrerenderRequest}
                      />
                    </ImageWrapper>
                    <CardText>{text}</CardText>
                  </CardHeader>
                  <Link href={url} passHref={newTab}>
                    <StyledLink linkStyle={type}>{linkText}</StyledLink>
                  </Link>
                </Card>
              ))
            )}
          </LinksWrapper>
        </ModalWrapper.Body>
      </ModalContentWrapper>
    </ModalWrapper>
  );
};

export default ReservedAreaModal;
